import React from 'react';

export interface ListBoxProps<T> {
  items: T[];
  activeIndex: number;
  renderLabel: (item: T) => React.ReactNode;
  onClickItem?: (index: number) => void;
}

export const ListBox = <T,>({
  items,
  activeIndex,
  renderLabel,
  onClickItem,
}: ListBoxProps<T>): React.ReactElement => {
  return (
    <ul className="listBoxContainer">
      {items.map((item, index) => (
        <li
          className={`listBoxItem ${index === activeIndex ? 'activeItem' : ''}`}
          key={index}
          onClick={() => onClickItem?.(index)}
        >
          {renderLabel(item)}
        </li>
      ))}
    </ul>
  );
};

export default ListBox;